document.addEventListener("DOMContentLoaded",function() {
  function moveNavLst() {
    var left_a = document.querySelectorAll(".nav-left-box a");
    var right_box = document.querySelectorAll(".nav-right-box");
    // right_box[0].style.display = "grid";
    for (var i = 0; i < left_a.length; i++) {
      left_a[i].setAttribute("index",i);
      left_a[i].addEventListener("mouseenter",function() {
        for (var i = 0; i < left_a.length; i++) {
          left_a[i].style.color = "#000";
        }
        this.style.color = "#ff8b21";
        
        for (var j = 0; j < right_box.length; j++) {
          right_box[j].style.display = "none";
        }
        if(right_box[this.getAttribute("index")]){
          right_box[this.getAttribute("index")].style.display = "grid";
        }
      })
    } 
  };
  moveNavLst();
  function moverNavImage() {
    var as = document.querySelectorAll(".nav-right-box a");
    for (var i = 0; i < as.length; i++) {
      as[i].addEventListener("mouseenter",function(e) {
        if(this.querySelector("img.nav-img-two")){ 
          this.querySelector("img.nav-img-one").style.display = "none";
          this.querySelector("img.nav-img-two").style.opacity = 1;
        }
      });
      as[i].addEventListener("mouseleave",function() {
        if(this.querySelector("img.nav-img-two")){ 
          this.querySelector("img.nav-img-one").style.display = "block";
          this.querySelector("img.nav-img-two").style.opacity = 0;
        }
      })
    }
  };
  moverNavImage();
  // mobile show and hide
  // function showBtn() {
  //    var items = document.querySelectorAll(".nav-right-box-mobile");
  //    for (var i = 0; i < items.length; i++) {
  //       // items[i].nextElementSibling.style.display = "none";
  //       items[i].setAttribute("index",0);
  //       items[i].addEventListener("click",function(){
  //         if(this.getAttribute("index") == 0){
  //           this.nextElementSibling.style.display = "grid";
  //           this.querySelector("span:last-child").innerHTML = "-";
  //           this.setAttribute("index",1);
  //         }else{
  //           this.nextElementSibling.style.display = "none";
  //           this.querySelector("span:last-child").innerHTML = "+";
  //           this.setAttribute("index",0);
  //         }
  //       })
  //    }
  // };
  function showBtn() {
     var items = document.querySelectorAll(".nav-right-box-mobile");
     for (var i = 0; i < items.length; i++) {
        // items[i].nextElementSibling.style.display = "none";
        items[i].setAttribute("index",0);
        items[i].addEventListener("click",function(){
          if(this.getAttribute("index") == 0){
            this.nextElementSibling.style.height = this.nextElementSibling.scrollHeight + 'px';
            this.querySelector("span:last-child").innerHTML = "-";
            this.setAttribute("index",1);
          }else{
            this.nextElementSibling.style.height = "0px";
            this.querySelector("span:last-child").innerHTML = "+";
            this.setAttribute("index",0);
          }
        })
     }
  };
  showBtn();
  // 首页
  new Swiper('#bannerShow', {
    // effect: 'fade',
    autoplay: true,//可选选项，自动滑动
    autoplay: {
      pauseOnMouseEnter:true,
      disableOnInteraction:false,
      delay: 6500,//1秒切换一次
    },
    loop: true, // 循环模式选项
    
    // 如果需要分页器
    // pagination: {
    //   el: '.banner-show-pagination',
    //   clickable: true
    // },
    
    // 如果需要前进后退按钮
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  // honors
  new Swiper('#honors', {
    grabCursor : true,
    autoplay: false,//可选选项，自动滑动
    // autoplay: {
    //   pauseOnMouseEnter:true,
    //   disableOnInteraction:false,
    // },
    // loop: true, // 循环模式选项
    slidesPerView: 5,
    spaceBetween: 30,
    // slidesOffsetBefore: 20,
    // slidesOffsetAfter: 20,

    // 如果需要分页器
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },

    // 如果需要前进后退按钮
    navigation: {
      nextEl: '.honors-next',
      prevEl: '.honors-prev',
    },

    breakpointsBase: 'container',
    breakpoints: {
      0: {  //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10
      },
      320: {  //当屏幕宽度大于等于320
        slidesPerView: 2.5,
        spaceBetween: 10
      },
      768: {  //当屏幕宽度大于等于768
        slidesPerView: 2.5,
        spaceBetween: 10
      },
      768: {  //当屏幕宽度大于等于768
        slidesPerView: 3,
        spaceBetween: 16
      },
      1200: {  //当屏幕宽度大于等于1280
        slidesPerView: 5,
        spaceBetween: 30
      }
    },

  });
})